/**
 * Firebase SDK initialisation.
 *
 * Exports:
 *   db      – Firestore instance (used by all components)
 *   storage – Firebase Storage instance (used for draft image uploads/deletes)
 *   app     – The underlying Firebase app (used by DraftReviewForm to
 *             initialise the Cloud Functions client)
 *
 * Note: Firebase API keys are intentionally public for web apps.
 * Access control is enforced by Firestore and Storage security rules
 * (firestore.rules / storage.rules), not by keeping the key secret.
 *
 * Build for Printsonalities: npm run build
 * Build for Lomae:           npm run build:lomae  (uses .env.lomae)
 */
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY            || "AIzaSyDRWCVVsJez6iX873vfCeL9PjPki-fDp5Y",
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN        || "testtobias12345.firebaseapp.com",
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID         || "testtobias12345",
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET     || "testtobias12345.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "683534870660",
  appId:             process.env.REACT_APP_FIREBASE_APP_ID             || "1:683534870660:web:e11f2a7bf6db0258ca7ad1"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export const storage = getStorage(app);
export { db, app };
